import * as _ from "lodash-es";
import React, { ChangeEvent, Component, useEffect, useMemo, useState } from "react";
import qbIcon from "../../../assets/images/quickbooks/QB_16x16.png";
import IOrder from "../../../models/IOrder";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IPurchaseOrderOrderItemDetail from "../../../models/IPurchaseOrderOrderItemDetail";
import IPurchaseOrderOrderItemDetailUI from "../../../models/IPurchaseOrderOrderItemDetailUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OrderEntryService from "../../../services/OrderEntryService";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import "./OrderActionColumn.scss";
import OwButton from "../../shared/OwButton/OwButton";
import IVendor_Source from "../../../models/IVendor_Source";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import ICatalog_Item_Vendor_Source_Map from "../../../models/ICatalog_Item_Vendor_Source_Map";
import UIService from "../../../services/UIService";
import IKitDetails from "../../../models/IKitDetails";
import UserTypesEnum from "../../../models/UserTypesEnum";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../../shared/OwAcceptCancelActions/OwAcceptCancelActions";

type Props = {
    data: IOrder_ItemUI;
    index: number;
    isManualPrice: boolean;
    order?: IOrder;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    showQuickBooksNotConnected?: boolean;
    toggleResetItemToCatalogDefaultFn: (row: IOrder_ItemUI) => void;
    viewChildItems: (row: IOrder_ItemUI, index: number) => void;
    toggleRowDetailViewFn: any;
    toggleRowEditModeFn: ProcessOrderEntryItemFn;
    toggleConfirmDeleteFn: (e: any, data: IOrder_ItemUI, index: number, ref: React.Ref<HTMLElement>) => void;
    duplicateOrderEntryItemFn: (data: IOrder_ItemUI) => void;
    rowRef: React.Ref<any>;
    isReadOnly: boolean;
    isBackorderView: boolean;
    checkRowForBackorder: (orderItemGuid: string, isChecked: boolean, qty: number) => void;
    // isPurchaseOrderView: boolean;
    // purchaseOrderRows: IPurchaseOrderOrderItemDetail[];
    // checkRowForPurchaseOrder: (orderItemGuid: string, isChecked: boolean, qty: number, vendorSource?: number) => void;
    // vendorSourcesForCatalogItems?: { [key: string]: IVendor_Source[] };
    /**
     * This is a view for only Wayfair
     */
    isAcknowledgeView: boolean;
    checkRowForAcknowledge: (orderItemGuid: string, isChecked: boolean, qty: number) => void;
    acknowledgeRows: { qty: number; orderItemGuid: string; isChecked: boolean }[];
    isDeallocateView: boolean;
    checkRowForDeallocate: (orderItemGuid: string, isChecked: boolean) => void;
    isBulkManualPriceView: boolean;
    checkRowForBulkManualPrice: (orderItemGuid: string, isChecked: boolean) => void;
};

type State = {
    rowIsChecked: boolean;
    backorderQty: number;
    ackQty: number;
    // purchaseOrderQty: number;
    // purchaseOrderRow: IPurchaseOrderOrderItemDetailUI;
    // availableVendorSourcesForCatalogItem: IVendor_Source[];
    // selectedVendorSource?: IVendor_Source;
    // selectedVendorSourceMap?: ICatalog_Item_Vendor_Source_Map;
    originalRowData: IOrder_ItemUI;
};

const OrderActionColumn = (props: Props) => {
    const [ackQty, setAckQty] = useState(props.data.qty);
    const [rowIsChecked, setRowIsChecked] = useState(false);
    const [backorderQty, setBackorderQty] = useState(0);
    const [originalRowData, setOriginalRowData] = useState(props.data);
    const isStandardView = useMemo(
        () => !(props.isAcknowledgeView || props.isBackorderView || props.isDeallocateView || props.isBulkManualPriceView),
        [props.isAcknowledgeView, props.isBackorderView, props.isDeallocateView, props.isBulkManualPriceView]
    );

    useEffect(() => {
        setOriginalRowData(props.data);
    }, [props.data]);

    useEffect(() => {
        props.checkRowForBackorder(props.data.guid, rowIsChecked, backorderQty);
        props.checkRowForAcknowledge(props.data.guid, rowIsChecked, ackQty);
        props.checkRowForDeallocate(props.data.guid, rowIsChecked);
        props.checkRowForBulkManualPrice(props.data.guid, rowIsChecked);
    }, [rowIsChecked, backorderQty]);

    const checkRowForBackorder = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setRowIsChecked(value);

        // setState(
        //     {
        //         rowIsChecked: value,
        //     },
        //     () => {
        //         props.checkRowForBackorder(props.data.guid, rowIsChecked, backorderQty);
        //     }
        // );
    };

    const checkRowForAcknowledge = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setRowIsChecked(value);

        // setState(
        //     {
        //         rowIsChecked: value,
        //     },
        //     () => {
        //         props.checkRowForAcknowledge(props.data.guid, rowIsChecked, ackQty);
        //     }
        // );
    };

    const checkRowForDeallocate = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;

        setRowIsChecked(value);
        // setState(
        //     {
        //         rowIsChecked: value,
        //     },
        //     () => {
        //         props.checkRowForDeallocate(props.data.guid, rowIsChecked);
        //     }
        // );
    };

    const checkRowForBulkManualPrice = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        setRowIsChecked(value);
    };

    // checkRowForPurchaseOrder = (e: ChangeEvent<any>) => {
    //     const value = e.target.type === "checked" ? e.target.checked : e.target.value;
    //     const name = e.target.name;
    //
    //     let purchaseOrderRow = purchaseOrderRow;
    //
    //     purchaseOrderRow.isChecked = value;
    //
    //     setState(
    //         {
    //             rowIsChecked: value,
    //             purchaseOrderRow,
    //         },
    //         () => {
    //             props.checkRowForPurchaseOrder(
    //                 props.data.guid,
    //                 rowIsChecked,
    //                 purchaseOrderQty,
    //                 selectedVendorSource?.id
    //             );
    //         }
    //     );
    // };

    const handleBackorderQtyChange = (e: ChangeEvent<any>) => {
        let value = Number(e.target.value);
        const name = e.target.name;

        if (Number(value) > props.data.qty) {
            value = props.data.qty;
        }

        setBackorderQty(Number(value));

        // setState(
        //     {
        //         backorderQty: value,
        //     },
        //     () => {
        //         props.checkRowForBackorder(props.data.guid, rowIsChecked, backorderQty);
        //     }
        // );
    };

    const handleAckQtyChange = (e: ChangeEvent<any>) => {
        let value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        value = Number(value);

        if (value < 0) {
            value = 0;
        } else {
            if (value > props.data.qty) {
                value = props.data.qty;
            }
        }

        setAckQty(value);

        // setState(
        //     {
        //         ackQty: value,
        //     },
        //     () => {
        //         props.checkRowForAcknowledge(props.data.guid, rowIsChecked, ackQty);
        //     }
        // );
    };

    let allowEditing = false;

    if (props.order) {
        // // Initial State for Most limited user.
        // switch (props.order.order_state_id) {
        //     case OrderStateEnum.PRELIMINARY:
        //     case OrderStateEnum.SUBMITTED:
        //         allowEditing = true;
        //         break;
        //
        //     default:
        //         allowEditing = false;
        //         break;
        // }

        if (!props.isReadOnly) {
            // console.log("allowEditing");
            allowEditing = true;

            if (props.data.is_ratio_item) {
                if (props.userModel.isSupplierUser) {
                    if (props.userModel.supplierUserToken?.user_type_id !== UserTypesEnum.ADMIN) {
                        allowEditing = false;
                    }
                } else {
                    allowEditing = false;
                }
            }
        }

        if (props.isBackorderView) {
            allowEditing = false;
        }

        if (props.isDeallocateView) {
            allowEditing = false;
        }

        if (props.isBulkManualPriceView) {
            allowEditing = false;
        }

        // if (props.isPurchaseOrderView) {
        //     allowEditing = false;
        // }
    }

    const is_quickbooks_connected = !!_.get(props.data, "Catalog_Item.qbo_item_id", false);
    // console.log('is_quickbooks_connected', is_quickbooks_connected);

    let rowHasIssue = false;

    if (props.showQuickBooksNotConnected && !is_quickbooks_connected) {
        rowHasIssue = true;
    }

    const showDetailView = props.data.Catalog_Item ? props.data.Catalog_Item.require_addl_input : props.data.showDetailView;

    const textMuted = "pointer";
    let disableSave = false;

    const orderModel = props.order || ({} as IOrder);

    const { enableAdd } = OrderEntryService.doInventoryValidation(
        props.data.Catalog_Item!,
        props.data.qty,
        props.order?.Order_Items || [],
        props.supplierModel,
        orderModel,
        0,
        props.data.Selected_Unit
    );

    if (props.data.Catalog_Item?.min_order_qty) {
        if (!enableAdd) {
            disableSave = true;
        }
    }

    return (
        <div className={"OrderActionColumn d-flex align-items-center"}>
            <div className={"state-circle me-4 " + (props.data.isSaved ? "bluish-green-bg" : "red-bg")} />

            <i className={"fad fa-exclamation-triangle text-warning " + (rowHasIssue ? "" : "invisible")}></i>

            <div className={showDetailView ? "" : "invisible"}>
                <i
                    className="far fa-chevron-down pointer"
                    onClick={() => {
                        props.toggleRowDetailViewFn(props.data, props.index);
                    }}
                />
            </div>

            {props.isAcknowledgeView ? (
                <div className={"d-flex align-items-center"}>
                    <OwCheckbox
                        name={"orderItemGuid"}
                        fn={checkRowForAcknowledge}
                        truthyVal={true}
                        falsyVal={false}
                        checked={rowIsChecked}
                    />
                    {!rowIsChecked ? null : (
                        <div className={"ms-2 w-10r d-flex align-items-center"}>
                            <OwLabel title={"qty"} noBottomMargin={true} className={"me-2"} />
                            <OwInputWrapper
                                name={"ackQty"}
                                type={"number"}
                                value={ackQty}
                                fn={handleAckQtyChange}
                                onWheelFn={UIService.stopScrollWheel}
                            />
                        </div>
                    )}
                </div>
            ) : null}

            {props.isBackorderView ? (
                <div className={"d-flex align-items-center"}>
                    <OwCheckbox
                        name={"orderItemGuid"}
                        fn={checkRowForBackorder}
                        truthyVal={true}
                        falsyVal={false}
                        checked={rowIsChecked}
                        disabled={props.data.qty <= 0}
                    />
                    {!rowIsChecked ? null : (
                        <div className={"ms-2 w-10r d-flex align-items-center"}>
                            <OwLabel title={"qty"} noBottomMargin={true} className={"me-2"} />
                            <OwInputWrapper
                                name={"backorderQty"}
                                type={"number"}
                                value={backorderQty}
                                fn={handleBackorderQtyChange}
                                onWheelFn={UIService.stopScrollWheel}
                                max={props.data.qty}
                            />
                        </div>
                    )}
                </div>
            ) : null}

            {props.isDeallocateView && (props.data.qty_reserved || 0) > 0 ? (
                <div className={"d-flex align-items-center"}>
                    <OwCheckbox
                        name={"orderItemGuid"}
                        fn={checkRowForDeallocate}
                        truthyVal={true}
                        falsyVal={false}
                        checked={rowIsChecked}
                    />
                    <span className={"ms-2 text-muted"}>Reserved: {props.data.qty_reserved}</span>
                </div>
            ) : null}

            {props.isBulkManualPriceView ? (
                <div className={"d-flex align-items-center"}>
                    <OwCheckbox
                        name={"orderItemGuid"}
                        fn={checkRowForBulkManualPrice}
                        truthyVal={true}
                        falsyVal={false}
                        checked={rowIsChecked}
                    />
                </div>
            ) : null}

            <div className={"itemRowActions " + (allowEditing ? "" : "d-none")}>
                <OwDeleteEditActions
                    isEditMode={props.data.rowEditMode}
                    onTrashClickFn={(e) => {
                        props.toggleConfirmDeleteFn(e, props.data, props.index, props.rowRef);
                    }}
                    onEditClickFn={() => {
                        props.toggleRowEditModeFn(props.data, {});
                    }}
                />
                <OwAcceptCancelActions
                    isEditMode={!props.data.rowEditMode}
                    disableAccept={disableSave}
                    onAcceptClickFn={() => {
                        if (!disableSave) {
                            props.toggleRowEditModeFn(props.data, { shouldAutoSave: true });
                        }
                    }}
                    onCancelClickFn={() => {
                        props.toggleRowEditModeFn(originalRowData, { shouldAutoSave: false });
                    }}
                />
                {props.supplierModel.has_child_items && props.data.Catalog_Item?.has_child_items ? (
                    <div className={props.data.rowEditMode ? "d-none" : ""}>
                        {/*<i*/}
                        {/*    className="fa-duotone fa-shapes pointer text-primary"*/}
                        {/*    title="Add Child Items"*/}
                        {/*    onClick={() => {*/}
                        {/*        props.viewChildItems(props.data, props.index);*/}
                        {/*    }}*/}
                        {/*/>*/}
                        <OwButton
                            leftIconClass={"fas fa-plus"}
                            title={"child_items"}
                            className={"mt-2 btn-warning btn-sm"}
                            fn={() => {
                                props.viewChildItems(props.data, props.index);
                            }}
                        />
                    </div>
                ) : null}
            </div>

            <div className={props.data.rowEditMode || !isStandardView ? "d-none" : "ms-2"}>
                <OwButton
                    centerIconClass={"fad fa-copy"}
                    className={"btn-secondary btn-sm"}
                    hoverTitle={"Duplicate / Clone"}
                    fn={() => {
                        props.duplicateOrderEntryItemFn(props.data);
                    }}
                />
            </div>

            <div className={props.data.rowEditMode && props.isManualPrice ? "mx-3" : "d-none"}>
                <OwButton
                    className="btn-warning"
                    centerIconClass="far fa-undo pointer"
                    hoverTitle="Reset to Default Catalog Price"
                    fn={() => {
                        props.toggleResetItemToCatalogDefaultFn(props.data);
                    }}
                />
            </div>

            <div className={"" + (props.showQuickBooksNotConnected ? "" : "d-none")}>
                <div className={is_quickbooks_connected ? "d-none" : "ms-2"}>
                    <img src={qbIcon} className={"dimmed ms-2"} title={"Not QuickBooks Online Connected"} />
                </div>
            </div>
        </div>
    );
};

export default OrderActionColumn;
